import { AxiosInstance } from "axios";
import {
  IFilterSchema,
  IListQueryStringSchema,
  ISortSchema,
} from "../../Schemas/ListQueryString";
import { IResponseBody } from "../../Schemas/EndPoint";
import { FileSchema } from "../../Schemas/File";

interface Filter extends IFilterSchema {
  column: FileListColumnFilterable;
}

interface Sort extends ISortSchema {
  column: FileListColumnSortable;
}

export enum FileListColumnFilterable {
  CAPTION = "caption",
  SIZE = "size",
  LENGTH = "length",
  VERIFYING_STATUS = "verifying_status",
  CREATED_AT = "created_at",
  UPDATED_AT = "updated_at",
  USER_ID = "user_id",
}
export enum FileListColumnSortable {
  CAPTION = "caption",
  SIZE = "size",
  LENGTH = "length",
  VERIFYING_STATUS = "verifying_status",
  CREATED_AT = "created_at",
  UPDATED_AT = "updated_at",
  ID = "id"
}

export interface FileListUrlParams {
  workspaceId: number;
}

export interface FileListQueryString extends IListQueryStringSchema {
  filters?: Filter[];
  sorts?: Sort[];
}

export interface IFileSchema extends FileSchema {
  user: {
    id: number;
    name: null | string;
    email: null | string;
    email_verified_at: null | string;
    mobile: string;
    mobile_verified_at: string;
    created_at: string;
    updated_at: string;
  };
  activities: {
    id: number;
    user_id: number;
    file_id: number;
    action: string;
    description: null | string;
    created_at: string;
    updated_at: string;
  }[];
}
export interface FileListResponseBody extends IResponseBody {
  data: {
    files: IFileSchema[];
    total: number;
  };
}

export class FileListRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath() {
    return `admin/files`;
  }

  async send(
    queryStrings?: FileListQueryString
  ): Promise<FileListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(this.getPath(), {
        params: queryStrings,
      });
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
